<template>
    <!-- 時刻選択入力 -->
    <div style="display: flex; gap: 2px;">
        <select v-model="Input.hour" :disabled="disabled" @change="changed" style="width: 40px">
            <option v-if="nullable" :value="-1">--</option>
            <option v-for="i in 24" :value="i-1" :key="i">{{ i-1 }}時</option>
        </select>
        <select v-model="Input.minute" :disabled="disabled" @change="changed" style="width: 40px">
            <option v-if="nullable" :value="-1">--</option>
            <option v-for="i in 60" :value="i-1" :key="i">{{ i-1 }}分</option>
        </select>
    </div>
</template>

<script>
import "../assets/api/tableTypes"

export default {
    props: {
        disabled: {
            default: false,
        },
        value: {
            default: -1
        },
        nullable:{
            default: true
        }
    },
    data() {
        return {
            Input:{
                hour: -1,
                minute: -1,
            },
        }
    },
    watch:{
        value:{
            handler(v){
                this.setValue(v)
            },
            immediate: true,
        }
    },
    methods: {
        changed(){
            let v = this.getValue()
            if(v != this.value){
                this.$emit("input", v)
            }
        },
        getValue(){
            if(this.Input.hour < 0 || this.Input.minute < 0) return -1
            return this.Input.hour * 60 + this.Input.minute
        },
        setValue(v){
            if(v < 0){
                this.Input.hour = -1
                this.Input.minute = -1
            }else{
                this.Input.hour = Math.trunc(v / 60)
                this.Input.minute = v % 60
            }
        }
    },
}
</script>

<style scoped>
    select{
        background: none;
        border: none;
        appearance: none;
        border-bottom: 1px solid gray;
        padding-left: 2px;
    }
</style>